// extracted by mini-css-extract-plugin
export default {"SharedFilesList":"SharedFile_SharedFilesList__Bi58M","noFileMessage":"SharedFile_noFileMessage__pw2jG"};